import {useEffect, useRef} from 'react';

/**
 * Fires the provided callback whenever the user returns to this tab/window:
 * - window `focus`
 * - document `visibilitychange` → visible
 * - window `pageshow` (covers bfcache restores)
 *
 * Mirrors the legacy `useOnReturnToTab` from iqosconnect-pwa-npi.
 */
const useOnReturnToTab = (callback: () => void) => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const onFocus = () => callbackRef.current();
        const onVisibility = () => {
            if (document.visibilityState === 'visible') callbackRef.current();
        };
        const onPageShow = () => callbackRef.current();

        window.addEventListener('focus', onFocus);
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('pageshow', onPageShow);

        return () => {
            window.removeEventListener('focus', onFocus);
            document.removeEventListener('visibilitychange', onVisibility);
            window.removeEventListener('pageshow', onPageShow);
        };
    }, []);
};

export default useOnReturnToTab;
